import {
  createUpdateInfiniteDataRecipe,
  createUpdateSingleItemRecipe,
} from '@autone/utils';

import { type TransformedAssortmentSkuLocationsResponse } from '../schemas/get-assortment-sku-locations.schema';

type RowIdentifiers = {
  skuId: string;
  locationId: string;
};

export const createUpdateSkuLocationInitialAllocationRecipe = (
  { skuId, locationId }: RowIdentifiers,
  newValue: number,
) =>
  createUpdateInfiniteDataRecipe(
    createUpdateSingleItemRecipe<TransformedAssortmentSkuLocationsResponse>({
      predicate: (item) =>
        item.sku.id === skuId && item.location.id === locationId,
      updateRecipe: (item) => {
        item.initial_allocation.value = newValue;
      },
    }),
  );

export const createUpdateSkuLocationCurrentAssortmentRecipe = (
  { skuId, locationId }: RowIdentifiers,
  newValue: boolean,
) =>
  createUpdateInfiniteDataRecipe(
    createUpdateSingleItemRecipe<TransformedAssortmentSkuLocationsResponse>({
      predicate: (item) =>
        item.sku.id === skuId && item.location.id === locationId,
      updateRecipe: (item) => {
        if (item.system_assortment_recommendation === 'hold') {
          item.system_assortment_recommendation =
            item.is_assorted.value === true ? 'assort' : 'unassort';
        } else {
          const systemRecommendsToAssort =
            item.system_assortment_recommendation === 'assort';
          if (systemRecommendsToAssort === newValue) {
            item.system_assortment_recommendation = 'hold';
          }
        }
        item.is_assorted.value = newValue;
        item.is_managed_by_user = true;
      },
    }),
  );
